// src/components/customer-search/CustomerContextMenu.tsx
import React from "react";
import { MyCustomerApiResponse } from "../../../store/services/customerService";
import BaseContextMenu, { BaseAction } from "./BaseContextMenu";

// Customer-specific actions that extend the base actions
export type CustomerAction = BaseAction | "createActivity" | "completeActivity";

interface CustomerContextMenuProps {
  contextMenu: {
    mouseX: number;
    mouseY: number;
    customer: MyCustomerApiResponse;
  } | null;
  onClose: () => void;
  onAction: (action: CustomerAction) => void;
}

const CustomerContextMenu: React.FC<CustomerContextMenuProps> = ({
  contextMenu,
  onClose,
  onAction,
}) => {
  // Customer-specific menu items to extend the base menu
  const customerMenuItems = null;

  // Handle action from base menu
  const handleBaseAction = (action: BaseAction | string) => {
    onAction(action as CustomerAction);
  };

  return (
    <>
      {/* Use the BaseContextMenu with customer-specific extensions */}
      <BaseContextMenu
        contextMenu={contextMenu}
        onClose={onClose}
        onAction={handleBaseAction}
        additionalMenuItems={customerMenuItems}
      />

      {/* Render Dialogs */}
    </>
  );
};

export default CustomerContextMenu;
